var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.userType === 'partner')?_c('PartnerLogin',{key:"partnerLogin"}):(_vm.userType === 'manager')?_c('ManagerLogin',{key:"managerLogin"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }